<div>
  <div
    class="matrix_layoutMain container matrix_layoutUseMatrix"
    v-bind:class="getClassNameContainer"
  >
    <div class="row">
      <appPageTitle></appPageTitle>
    </div>
    <div class="row">
      <div class="col-md-9 matrix_layoutMatrixContainerColMain">
        <!-- <div class="matrix_layoutHeader">
          <appProductPartsNamesContainer
          ></appProductPartsNamesContainer>
        </div> -->
        <div class="matrix_productPartsMainContainer">
          <appProductParts></appProductParts>
          <appInformation></appInformation>
          <!-- <appBackToMatrixButton></appBackToMatrixButton> -->
          <!-- <appPersonalizationButton
            class="matrix_personzalizeButtonMain"
            v-show="getMatrixComplete"
          ></appPersonalizationButton> -->
        </div>
        <!-- <div class="matrix_summaryInformation">
          <appSummaryTable></appSummaryTable>
          <appInformationTable></appInformationTable>
        </div> -->
        <div class="matrix_summaryInformation">
          <appFactsheet></appFactsheet>
        </div>
      </div>
      <div class="col-md-3 matrix_layoutMatrixContainerColSidebar">
        <appQuantityTable v-if="!getIsMobile">
          <appQuantityContainer></appQuantityContainer>
          <appInputQuantity></appInputQuantity>
        </appQuantityTable>
        <appSaveCustomizationPopUp></appSaveCustomizationPopUp>
        <!-- <appAddToCartButton
          class="matrix_addToCartButtonMain"
          style="display: none"
        ></appAddToCartButton>
        <appSummarySelectedPageOptions></appSummarySelectedPageOptions>
        <appOtherOptionsTable>
          <appOtherOptionsContainer></appOtherOptionsContainer>
        </appOtherOptionsTable>
        <appOptionsTable>
          <appOptionsContainer></appOptionsContainer>
          <appInputCustomFormatInsert></appInputCustomFormatInsert>
        </appOptionsTable>
        <appPersonalizationButton
          class="matrix_personzalizeButtonMobile"
        ></appPersonalizationButton>
        <appAddToCartButton
          class="matrix_addToCartButtonMobile"
          style="display: none"
        ></appAddToCartButton>
        <appQuotationButton></appQuotationButton> -->
        <div v-if="getIsMobile" class="matrix_productPartsMainContainer">
          <appProductParts></appProductParts>
          <appInformation></appInformation>
          <!-- <appBackToMatrixButton></appBackToMatrixButton> -->
        </div>
        <appQuantityTable v-if="getIsMobile">
          <appQuantityContainer></appQuantityContainer>
          <appInputQuantity></appInputQuantity>
        </appQuantityTable>
      </div>
    </div>
    <div class="row">
      <div class="flex flex-column matrix_downloadCreateButtonsContainer matrix_layoutDownloadPersonalizeContainer">
        <template v-for="pp in getProductPartsNames">
          <div v-if="getPPFactsheet(pp.code)">
            <div class="matrix_downloadCreateButtonsLabel">{{pp.label}}</div>
            <div class="matrix_uploadDownloadCreateButtons">
              <appDownloadTemplateButton :ppCode="pp.code"></appDownloadTemplateButton>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="row">
      <div class="matrix_layoutPersonalizationButtonContainer">
        <appPersonalizationButton></appPersonalizationButton>
      </div>
    </div>
  </div>
  <div class="matrix_summaryFooterContainer">
    <appSummaryFooter></appSummaryFooter>
  </div>
</div>
